/**
 * GitHub pull-request link labels.
 *
 * Both surfaces that link a label's `pr_url` — the review queue sidebar
 * and the trajectories flag editor — name the PR the same way, so the
 * parsing lives here rather than once per page.
 */

/** `PR #123` from a GitHub pull URL, or a plain label when it has no number. */
export function prLabel(prUrl: string): string {
  const number = /\/pull\/(\d+)\/?$/.exec(prUrl)?.[1]
  return number === undefined ? 'View PR' : `PR #${number}`
}

/**
 * The eval-PR v3 stamp for a label whose episode settled without opening
 * a PR: dropped, privacy-blocked, unbuildable, or conflicting verdicts.
 * The column is non-NULL on purpose (that is what stops the label being
 * re-consumed), so every surface that reads `pr_url` has to know this is
 * not an address. Mirrors NO_PR_STAMP in
 * `api/app/data/eval_pr_v3/run.py`.
 */
export const NO_PR_STAMP = 'eval-pr-v3://settled-without-pr'

/**
 * Whether a stamped `pr_url` is something a reviewer can actually open.
 *
 * It often is not. v3 writes NO_PR_STAMP, and v2's dry-run passes wrote
 * `excluded-local-dev`. Both mean "this label is settled and there is no
 * PR", and both would render as a link into nothing. Callers narrow the
 * null case themselves: a null column means the agent has not reached
 * this label yet, which is a third state, not a second kind of non-link.
 */
export function isPrLink(prUrl: string): boolean {
  return prUrl.startsWith('http')
}
